import { create } from 'zustand';
import type { RoomDto } from '@shared/protocol';

interface RoomState {
  room: RoomDto | null;
  setRoom: (r: RoomDto | null) => void;
  clear: () => void;
}

export const useRoomStore = create<RoomState>((set) => ({
  room: null,
  setRoom: (r) => set({ room: r }),
  clear: () => set({ room: null }),
}));
